import React from 'react';
import { motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
import { FlameIcon } from './icons/Icons';
/**
 * Sticky urgency bar with a live countdown timer. Pinned to top of viewport.
 */
export function UrgencyBar() {
  const {
    minutes,
    seconds,
    total
  } = useCountdown(14 * 60 + 59);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-[#7a1e12] text-white shadow-lg" data-id="element-428" data-mp="2yv52c9q4i9zm">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-center gap-1.5 px-4 py-2.5 text-center sm:flex-row sm:gap-4" data-id="element-429" data-mp="2yx7xf864utb7">
        <div className="flex items-center gap-2" data-id="element-430" data-mp="2p4sf29qxc2ps">
          <span className="animate-flicker text-amber-300" data-id="element-431" data-mp="2p3914psqq3r6">
            <FlameIcon className="h-5 w-5" strokeWidth={2.2} data-id="element-432" data-mp="2k7tou2adsfwv" />
          </span>
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-amber-200 sm:text-xs" data-id="element-433" data-mp="2f7nsi8t6258g">
            Barra de Urgencia
          </span>
        </div>
        <p className="text-xs leading-tight text-amber-50 sm:text-sm" data-id="element-434" data-mp="2b86prn54jm6z">
          <span className="font-semibold" data-id="element-435" data-mp="1rvzpt7ve2ju6">ATENCIÓN:</span> la oferta de{' '}
          <span className="font-bold text-white" data-id="element-436" data-mp="1wp2jdg061tad">$10.99</span> expira cuando el
          contador llegue a cero.
        </p>
        <motion.div animate={total <= 60 ? {
        scale: [1, 1.06, 1]
      } : {}} transition={{
        duration: 1,
        repeat: Infinity
      }} className="flex items-center gap-1 rounded-lg bg-black/30 px-3 py-1 font-display text-lg font-extrabold tabular-nums tracking-widest sm:text-xl" data-id="element-437" data-mp="1i0y1ufcunnt6">
          <span data-id="element-438" data-mp="25opdrhuh9ytx">{pad(minutes)}</span>
          <span className="animate-pulse text-amber-300" data-id="element-439" data-mp="25no158xtd4a3">:</span>
          <span data-id="element-440" data-mp="q7you1vxa9ng">{pad(seconds)}</span>
        </motion.div>
      </div>
    </div>;
}